module.exports = __webpack_public_path__ + "static/media/weldingCard.a70229df.png";